var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtistsw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.524 1.48119C12.6727 1.0185 13.3273 1.0185 13.476 1.48119L15.9574 9.20213C16.0238 9.40892 16.2162 9.54915 16.4334 9.54915H24.4747C24.9578 9.54915 25.16 10.1662 24.7707 10.4521L18.2557 15.2377C18.0824 15.365 18.0099 15.5889 18.0757 15.7936L20.562 23.5299C20.7103 23.9915 20.1807 24.3729 19.79 24.0859L13.296 19.3157C13.1199 19.1864 12.8801 19.1864 12.704 19.3157L6.21003 24.0859C5.81925 24.3729 5.28965 23.9915 5.43801 23.5299L7.92428 15.7936C7.99008 15.5889 7.91758 15.365 7.74425 15.2377L1.22928 10.4521C0.839988 10.1662 1.04225 9.54915 1.52528 9.54915H9.56662C9.78382 9.54915 9.97618 9.40892 10.0426 9.20213L12.524 1.48119Z",
    stroke: "white",
    strokeWidth: 1.55769
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistsw);
export default __webpack_public_path__ + "static/media/Artistsw.fc89182f8aec2aa6c920a86e1a42148d.svg";
export { ForwardRef as ReactComponent };